import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const charToValue = (c: string): number => {
  const upper = c.toUpperCase();
  if (/[0-9]/.test(upper)) return Number(upper);
  return upper.charCodeAt(0) - 48;
};

export function cnpjValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const raw = control.value || '';

    const cnpj = raw.replace(/[^A-Za-z0-9]/g, '').toUpperCase();

    if (cnpj.length !== 14) {
      return { cnpjInvalid: true };
    }

    // Check for known invalid CNPJs
    const knownInvalidCNPJs = [
      '00000000000000',
      '11111111111111',
      '22222222222222',
      '33333333333333',
      '44444444444444',
      '55555555555555',
      '66666666666666',
      '77777777777777',
      '88888888888888',
      '99999999999999',
    ];
    if (knownInvalidCNPJs.includes(cnpj)) {
      return { cnpjInvalid: true };
    }

    // Validate first check digit
    let size = cnpj.length - 2;
    let numbers = cnpj.substring(0, size);
    const digits = cnpj.substring(size);
    let sum = 0;
    
    const weights1 = [5,4,3,2,9,8,7,6,5,4,3,2];

    for (let i = 0; i < size; i++) {
      sum += charToValue(numbers.charAt(i)) * weights1[i];
    }

    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== Number(digits.charAt(0))) {
      return { cnpjInvalid: true };
    }

    // Validate second check digit
    size = size + 1;
    numbers = cnpj.substring(0, size);
    sum = 0;
    const weights2 = [6,5,4,3,2,9,8,7,6,5,4,3,2];

    for (let i = 0; i < size; i++) {
      sum += charToValue(numbers.charAt(i)) * weights2[i];
    }

    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== Number(digits.charAt(1))) {
      return { cnpjInvalid: true };
    }

    return null; // CNPJ is valid
  };
}
